import {ARRAY, STRING, guard} from '@acng/frontend-rubicon';
import {createGlobalContext} from '@acng/frontend-relativity';

import {get} from 'acng/core/service/backend.js';
import {localStore, PROFILE_VISITS} from '../../api/browser-storage.js';

/**
 * @type {Promise<void> | undefined}
 */
let amateurVisitsFromApi;

/**
 * @type {Array<string>}
 */
const amateurVisits = [];

const ctxAmateurVisits = createGlobalContext(amateurVisits);

const getUserVisitsFromLocalStorage = () => {
  const data = localStore[PROFILE_VISITS] ?? [];
  ASSERT: guard(data, ARRAY(STRING));
  return data;
};

const userVisits = getUserVisitsFromLocalStorage();


/**
 * @param {string} amateurId
 */
export const userVisitsAmateur = (amateurId) => {
  let i = userVisits.indexOf(amateurId);
  if (i >= 0) {
    userVisits.splice(i, 1);
  }
  userVisits.unshift(amateurId);
  localStore[PROFILE_VISITS] = userVisits;
};

/**
 * @param {string} amateurId
 */
export const amateurVisitsUser = (amateurId) => {
  let i = amateurVisits.indexOf(amateurId);
  if (i >= 0) {
    amateurVisits.splice(i, 1);
  }
  amateurVisits.unshift(amateurId);
};

export const getAmateurVisits = async () => {
  if (!amateurVisitsFromApi) {
    amateurVisitsFromApi = (async () => {
      const data = await get('amateur-profile/visits');
      ASSERT: guard(data, ARRAY(STRING));

      amateurVisits.length = 0;
      data.reverse().forEach((a) => amateurVisitsUser(a));
    })();
  }
  await amateurVisitsFromApi;

  return amateurVisits;
};
